import { render } from "./UserAccountMenu.vue?vue&type=template&id=4781bb96&scoped=true&ts=true"
import script from "./UserAccountMenu.vue?vue&type=script&lang=ts"
export * from "./UserAccountMenu.vue?vue&type=script&lang=ts"

import "./UserAccountMenu.vue?vue&type=style&index=0&id=4781bb96&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4781bb96"]])

export default __exports__